<template>
	<div id="breadcrumb">
		<v-flex
		xs12
		md12
		>
			<hr class="hr-style-top">

			<v-breadcrumbs :large="true" class="justify-center" :items="items">
				<template v-slot:divider>
						<v-icon class="indigo--text">forward</v-icon>
				</template>
			</v-breadcrumbs>			
			<hr class="hr-style-bottom">
		</v-flex>
	</div>
</template>

<script>
	export default {
	  name: 'Breadcrump',
	  data: () => ({
		items: [
		  {
			text: 'Vul dit document in',
			disabled: false,
		  },
		  {
			text: 'Ontvang offerte',
			disabled: false,
		  },
		  {
			text: 'Bevestig dan het project',
			disabled: false,
		  },
		  {
			text: 'Bestel daarna de definitieve materiaallijst',
			disabled: false,
		  },
		  {
			text: 'Ontvang gratis boor & legplan',
			disabled: false,
		  }
		]
	  })
	}
</script>

<style>
hr.hr-style-top {
    height: 12px;
    border: 0;
    box-shadow: inset 0 12px 12px -12px rgba(0, 0, 0, 0.5);
}
hr.hr-style-bottom {
    height: 12px;
    border: 0;
    box-shadow: inset 0 -12px 12px -12px rgba(0, 0, 0, 0.5);
}
#breadcrumb {
	margin-bottom: 20px;
}
</style>
